// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__Yaknq","form":"styles_form__YHNjQ","info":"styles_info__LFkF5","row":"styles_row__KmzyK","label":"styles_label__Plsk2"};